import * as React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { ErrorMessage } from '@src/app/_global/components/error-messages/default-error-message';
import { IntelliselCarousel } from '@src/app/intellisel/components/IntelliselCarousel';
import { INTELLISEL_TRANSACTION_CODES } from '@src/app/_global/utility/constants';
import '../payments.scss';
import { getCurrencyFormatter } from '@src/app/_global/utility/formatters';
import { CustomOrder } from '@CDSGlobal/gc-backend';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import ConfirmationDetail from '@src/app/_global/components/confirmation/ConfirmationDetail';
import moment from 'moment';
interface ResponseViewProps {
  onCancel: () => void;
  result: any;
  intelliselOffers: any;
  paymentAmount: any;
  selectedOrders: CustomOrder[];
  adminConfig: any;
  clientConfig: any;
  billToAddress: any;
  directViewLogin: any;
}
const SuccessView: React.SFC<any> = props => {
  const { paymentAmount, selectedOrders, result, billToAddress, directViewLogin } = props;
  let paymentConfMessage = 'Your payment of ' + paymentAmount + ' has been processed for the following orders:' + '\n';
  // combine selectedOrder and pmt response object by account number, for display
  let transformedOrders: any[] = [];
  for (let i = 0; i < selectedOrders.length; i++) {
    if (selectedOrders[i].systemCode === 'CORE') {
      let payload = result.accountResponse.paymentsPayloads[0].invoiceAmountPaid.find(invoice => 
        (selectedOrders[i].invoiceNumber === invoice.invoiceNumber));
      let newOrder =  {...selectedOrders[i], ...payload };
      transformedOrders.push(newOrder);
    } else {
      let payload = result.accountResponse.paymentsPayloads.find(pmt => 
        (selectedOrders[i].billToAccountNumber === pmt.accountNumber &&
        selectedOrders[i].prodIdAlias === pmt.prodIdAlias));
      let newOrder =  {...selectedOrders[i], ...payload };
      transformedOrders.push(newOrder);
    }
  }
  return (
    <>
      <div className="conf-print">
        <button
          tabIndex={0}
          className="print-page icon-blue pointer fa fa-2x fa-print print-btn no-print"
          title="Print this page."
          onClick={() =>  window.print()}
        />
      </div>
      <div className="h5 mb-3">
        <FormattedMessage
            id="cancelconf.heading"
            description="heading cancelconf"
            defaultMessage="Thank you for your payment."
          />
      </div>
      <div>
          {result && result.success && !directViewLogin &&             
            <ConfirmationDetail
              currentOrder={null}
              customer={billToAddress}
            />
          }
          {result && result.success && directViewLogin &&             
            <div className="confirmation-address-detail mb-2">
              <span>{billToAddress.address.name}</span><br/>
            </div>
          }
      </div>
      <div className="mb-2 mt-2">
        <FormattedMessage
            id="paymentconf.heading2"
            description="heading paymentconf2"
            defaultMessage={paymentConfMessage}
          />
      </div>

      {transformedOrders 
        && transformedOrders.map(order => (
          
          <Row key={order.orderNumber}>
            <Col sm={12} md={6}>
                {order && result && result.success && !directViewLogin &&
                  <>
                    <div className="paid-product-name">
                      <div className="confirmation-order-detail">
                        <span className="bold">Account Number: </span>{order.billToAccountNumber}<br/>
                        <span className="bold">Product Description: </span>{order.productName}<br/>
                        <span className="bold">Order Date: </span>{moment(order.createdDate).format('MMM D, YYYY')}<br/>
                        <span className="bold">Order/Invoice Number:</span> {order.orderNumber}<br/>
                        <span className="bold" key={'pmtamt-' + order.orderNumber}>Amount Paid: </span>{getCurrencyFormatter(order.systemCode === 'CORE' ? order.currencyCode : 'USD').format(order.amountPaid)}<br/>
                      </div>                       
                    </div>                   
                  </>
                }
                {order && result && result.success && directViewLogin &&
                  <>
                    <div className="paid-product-name">
                      <div className="confirmation-order-detail">
                        <span className="bold">Product Description: </span>{order.productName}<br/>
                      </div>
                        <span className="bold" key={'pmtamt-' + order.orderNumber}>Amount Paid: </span>{getCurrencyFormatter(order.systemCode === 'CORE' ? order.currencyCode : 'USD').format(order.amountPaid)}<br/>
                    </div>                   
                  </>
                }
            </Col>
          </Row>
        ))
      }
    </>
  );
};

export const ResponseView: React.SFC<ResponseViewProps> = props => {
  const { result, onCancel, intelliselOffers, paymentAmount, selectedOrders, adminConfig, clientConfig, billToAddress, directViewLogin } = props;
  let pageIntroTable = getAdminConfigTableItem(
    adminConfig,
    clientConfig,
    'PageIntro',
  );
  let pageIntro;
  if (pageIntroTable.PageIntroductions) {
    pageIntro = pageIntroTable.PageIntroductions.find(intro => {
      return intro.route === 'payments';
    });
  }
  let pageIntroDescHtml = document.getElementsByClassName('page-intro-desc') || null;
  if (pageIntroDescHtml && pageIntroDescHtml.length > 0) {
    pageIntroDescHtml[0].innerHTML = pageIntro ? (pageIntro.confDescription ? pageIntro.confDescription : pageIntro.description ) : '';
  }
  let pageIntroLabelHtml = document.getElementsByClassName('page-intro-label') || null;
  if (pageIntroLabelHtml && pageIntroLabelHtml.length > 0) {
    pageIntroLabelHtml[0].innerHTML = pageIntro ? pageIntro.label + ' Confirmation' : '';
  }
  let pageHeader = document.getElementsByClassName('page-header') || null;
  if (pageIntro && pageIntro.hideLabel && pageHeader && pageHeader.length > 0) {
    let span = pageHeader[0].querySelector('span');
    if (span) {
      span.innerHTML = 'Make a Payment Confirmation'; 
    }
  }
  let newCustomerAddr = {address: billToAddress};
  return (
    <div className="payment-response-view">
      <Row>
        <Col xs={12} sm={12} md={12}>

          <div className="mt-4 mb-4">
            {result && result.success && 
              <SuccessView 
                selectedOrders={selectedOrders} 
                paymentAmount={getCurrencyFormatter(selectedOrders[0].systemCode === 'CORE' ? selectedOrders[0].currencyCode : 'USD').format(paymentAmount)} 
                result={result} 
                billToAddress={newCustomerAddr}  
                directViewLogin={directViewLogin}
              />}
            {result && !result.success && <ErrorMessage onReset={onCancel}/>}
          </div>
        </Col>
      </Row>
    
      <Container>
        {result && result.success && intelliselOffers.UpsellEnabled && !directViewLogin && (
          <div>
            <IntelliselCarousel 
              transactionCode={INTELLISEL_TRANSACTION_CODES.PAYMENT_CONF}
            />
          </div>
        )}
      </Container>
      {!directViewLogin && (
        <Row className="mt-auto">
          <Col xs={12} sm={12} md={12}>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={onCancel}
              >
                <FormattedMessage
                  id={'app.cancel'}
                  description={'close button text'}
                  defaultMessage={'Close'}
                />
              </button>
            </div>
          </Col>
        </Row>
      )}

    </div>
  );
};